<div class="spinner" data-cy="loading-spinner">
    <img src="../../../../assets/ORCAN-icon.svg">
</div>
